import "date-fns";
import React, { useRef, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useHistory } from "react-router-dom";
import firestore from "../../firebase.config";

import {
    Avatar,
    Button,
    CssBaseline,
    TextField,
    MenuItem,
    FormControlLabel,
    Checkbox,
    Link,
    Grid,
    Box,
    Typography,
    Container,
    Snackbar,
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import moment from "moment";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {"Copyright © "}
            <Link color="inherit" href="/">
                VLearnAI
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: "#FDE21A",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    label: {
        alignItems: "left",
    },
    error: {
        margin: theme.spacing(3, 0, 2),
    }
}));

const genders = [
    {
        value: "female",
        label: "Female",
    },
    {
        value: "male",
        label: "Male",
    },
    {
        value: "other",
        label: "Other",
    },
];

export default function SignUp() {
    const classes = useStyles();
    const fnameRef = useRef();
    const lnameRef = useRef();
    const emailRef = useRef();
    const genderRef = useRef();
    const passwordRef = useRef();
    const passwordConfirmRef = useRef();
    const { signup } = useAuth();
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    //const [gender, setGender] = useState("");
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [open, setOpen] = React.useState(false);
    /*const handleChange = (event) => {
        setGender(event.target.value);
    };*/

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    async function handleSubmit(e) {
        e.preventDefault();

        if (passwordRef.current.value !== passwordConfirmRef.current.value) {
            return setError("Password Entered does not match!");
        }

        try {
            setError("");
            setLoading(true);
            const user = await signup(
                emailRef.current.value.trim(),
                passwordRef.current.value
            );
            const yearDob = new Date(selectedDate).getFullYear();
            const yearNow = new Date().getFullYear();
            const age = yearNow - yearDob;
            const doc_id = `${user.user.uid}`;

            const userinfo = {
                userid: doc_id,
                email: emailRef.current.value,
                fname: fnameRef.current.value,
                lname: lnameRef.current.value,
                gender: genderRef.current.value,
                dob: moment(selectedDate).format("YYYY MM DD"),
                dobYear: yearDob,
                age: age,
                role: "user",
            };

            const adduser = await firestore
                .collection("users")
                .doc(doc_id)
                .set(userinfo);

            console.log(adduser);

            console.log(
                "fname: ",
                fnameRef.current.value,
                "lname: ",
                lnameRef.current.value,
                "email: ",
                emailRef.current.value,
                "gender: ",
                genderRef.current.value,
                "DOB: ",
                selectedDate,
                "DOB year: ",
                yearDob,
                "age: ",
                age
            );
            history.push("/");
        } catch (err) {
            setError(err.message);
            console.log(err.message);
        }
        setLoading(false);
    }

    return (
        <>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Sign up
                    </Typography>

                    {error && (
                        <Alert variant="outlined" severity="error" className={classes.error}>
                            <AlertTitle>Error</AlertTitle>
                            {error}
                        </Alert>
                    )}
                    <form
                        onSubmit={handleSubmit}
                        className={classes.form}
                        noValidate
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    autoComplete="fname"
                                    name="firstName"
                                    variant="outlined"
                                    inputRef={fnameRef}
                                    required
                                    fullWidth
                                    id="firstName"
                                    label="First Name"
                                    autoFocus
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    inputRef={lnameRef}
                                    required
                                    fullWidth
                                    id="lastName"
                                    label="Last Name"
                                    name="lastName"
                                    autoComplete="lname"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    inputRef={emailRef}
                                    required
                                    fullWidth
                                    id="myemail"
                                    label="Email Address"
                                    name="email"
                                    autoComplete="email"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    margin="normal"
                                    id="gender"
                                    select
                                    label="Gender"
                                    inputRef={genderRef}
                                    required
                                    //onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                >
                                    {genders.map((option) => (
                                        <MenuItem
                                            key={option.value}
                                            value={option.value}
                                        >
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        margin="normal"
                                        inputVariant="outlined"
                                        id="date-picker-dialog"
                                        label="Date of Birth"
                                        format="MM/dd/yyyy"
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    inputRef={passwordRef}
                                    required
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    type="password"
                                    id="password"
                                    autoComplete="current-password"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    inputRef={passwordConfirmRef}
                                    required
                                    fullWidth
                                    name="password-confirm"
                                    label="Confirm Password"
                                    type="password"
                                    id="password-confirm"
                                    autoComplete="password-confirm"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    required
                                    control={
                                        <Checkbox
                                            value="allowExtraEmails"
                                            color="primary"
                                        />
                                    }
                                    label="I understand this is mainly for research purpose only."
                                    classes={{
                                        label: classes.label,
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            disable={loading}
                        >
                            Sign Up
                        </Button>
                        <Grid container justify="flex-end">
                            <Grid item>
                                <Link href="/login" variant="body2">
                                    Already have an account? Sign in
                                </Link>
                            </Grid>
                        </Grid>
                    </form>
                </div>
                <Box mt={5}>
                    <Copyright />
                </Box>
            </Container>
        </>
    );
}
